import { ForwardedRef, forwardRef, memo, useEffect } from 'react'

import { Zoom } from '@mui/material'
import { SvgIconComponent } from '@material-ui/icons'
import { StyledToolbarButton } from './ToolbarButton.styles'

interface ToolbarButtonProps {
  className?: string
  color?: string
  htmlColor?: string
  title?: string
  Icon: SvgIconComponent
  display?: boolean
  disabled?: boolean
  selected?: boolean
  onClick?: () => void
}

const ToolbarButton = forwardRef<HTMLButtonElement, ToolbarButtonProps>(
  (props, ref: ForwardedRef<HTMLButtonElement>) => {
    const {
      className,
      color = 'action',
      htmlColor,
      display = true,
      selected = false,
      disabled = false,
      Icon,
      onClick = () => {},
      ...rest
    } = props

    useEffect(() => {
      window.dispatchEvent(new CustomEvent('resize'))

      return () => {
        window.dispatchEvent(new CustomEvent('resize'))
      }
    }, [])

    if (!display) {
      return null
    }

    return (
      <Zoom in={display} unmountOnExit>
        <StyledToolbarButton
          ref={ref}
          className={className}
          disabled={disabled}
          onClick={onClick}
          selected={selected}
          {...rest}
        >
          <Icon color={htmlColor ? undefined : color} htmlColor={htmlColor} />
        </StyledToolbarButton>
      </Zoom>
    )
  }
)

export default memo(ToolbarButton)
